export const FINISH_RECLAIM_SETUP_TASK_ID = "finish-reclaim-setup";
export const RECLAIM_WALKTHROUGH_TASK_ID = "take-reclaim-walkthrough";
export const ENABLE_AI_AUTOMATION_TASK_ID = "enable-ai-automation";
export const SET_UP_BILLING_TASK_ID = "set-up-billing";
